import { subscriptionHandlerInstance } from "./SubscriptionHandlerInstance";
if (typeof window !== "undefined") {
    Object.defineProperty(window, "wxcc", {
        configurable: false,
        writable: false,
        value: Object.freeze({
            rtdwc: subscriptionHandlerInstance
        })
    });
}
